<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="success-message-title">
        {{ successMessageTitle }}
      </v-card-title>
      <v-card-text class="success-message-text">
        {{ successMessage }}
      </v-card-text>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn
          class="white--text"
          @click="onCancelClick"
          style="
            background-color: #6c757d;
            width: 120px;
            height: 50px;
            border-radius: 50px;
            margin-right: 10px;
          "
        >
          Отмена
        </v-btn>
        <v-btn
          class="white--text"
          @click="onOkClick"
          style="
            background-color: #dc3545;
            width: 150px;
            height: 50px;
            border-radius: 50px;
          "
        >
          {{ successButton }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SuccessMessageWrapper",
  props: {
    successButton: {
      type: String,
      default: "OK",
    },
  },
  data() {
    return {
      successMessage: "SuccessMessageText",
      dialog: false,
      successMessageTitle: "SuccessMessageTitle",
    };
  },
  methods: {
    showSuccessMessage(title, message) {
      this.successMessageTitle = title;
      this.successMessage = message;
      this.dialog = true;
    },
    onOkClick() {
      this.$emit("ok-clicked");
      this.dialog = false;
    },
    onCancelClick() {
      this.$emit("cancel-clicked");
      this.dialog = false;
    },
  },
};
</script>

<style>
.success-message-title {
  color: #23919e;
  font-weight: bold;
  justify-content: center;
}

.success-message-text {
  color: black;
  text-align: center;
}
</style>
